<template>
  <div id="page-full">
    <div class="row">
      <div class="col-12 text-right">
        <div class="p-3">
          <button class="btn btn-primary btn-sm" @click="fnPrint">
            <i class="las la-print"></i>Print
          </button>
        </div>
      </div>
    </div>
    <appVSAEOMSummarySettlementReport
      :prosData="rptData"
      :propsDealerIds="dataObj.dealerIds"
      :propsFromDate="dataObj.fromDate"
      :propsToDate="dataObj.toDate"
      ref="reportVSAEOMSummary"
    ></appVSAEOMSummarySettlementReport>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import datePicker from 'vue2-datepicker'

import appVSAEOMSummarySettlementReport from '../../../components/admin/reports/VSAEOMSummarySettlementReport.vue'

import * as reportService from '../../../services/report.service'
import * as messageService from '../../../services/message.service'

export default {
  name: 'Report',
  components: {
    datePicker,
    appVSAEOMSummarySettlementReport
  },
  mounted() {},
  data() {
    return {
      errors: {},
      rptData: [],
      dataObj: {}
    }
  },
  computed: {
    ...mapGetters(['getDealerDropdown'])
  },
  methods: {
    ...mapActions(['fetchDealerDropdown']),
    async fnGenerate() {
      try {
        this.errors = {}

        const res = await reportService.getAllSettledReport(this.dataObj)

        this.rptData = res.data
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              'Something wrong'
            )
            break
        }
      }
    },
    fnPrint() {
      window.print()
    }
  },
  created() {
    Object.assign(this.dataObj, JSON.parse(localStorage.getItem('dataObj')))
    this.fnGenerate()
  },
  watch: {}
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
#page-full {
  width: 1100px;
  margin: auto;
}
@page {
  /* size: A4 portrait;  */
  width: 210mm;
  height: 280mm;
  margin: 20px 20px 20px 20px;
  padding: 0;
}
@media print {
  body * {
    visibility: hidden;
  }
  #quickQuotePage {
    display: none !important;
  }
  #quickQuotePage2 {
    display: none !important;
  }
  #printMe,
  #printMe * {
    visibility: visible !important;
  }
  #printMe {
    position: absolute !important;
    left: 0px !important;
    top: 0px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
